<template>
  <div>
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card>
      <div class="text-left pa-6">
        <span>{{ $t("forms.info.newWorkplaceForm") }}</span>
        <br />
        <span
          v-if="show_link"
          v-html="$t('forms.info.link_extend_workplace_assignation')"
        ></span>
        <a
          v-if="show_link"
          @click="
            $router.push(
              '/researchers/' +
                investigator.id +
                '/forms/workplaceAssignationForm'
            )
          "
        >
          {{ $t("section.workplaceAssignationForm") }}
        </a>
        <br />
        <v-divider class="mt-10" />
      </div>
      <v-form class="pa-6" ref="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-combobox
              v-model="workplaceSelected"
              :items="workplaces"
              item-text="name"
              :label="$t('label.laboratory')"
              return-object
              outlined
              :readonly="disabledForm"
              :rules="rules.fieldRequired"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="menu_exp_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              :disabled="disabledForm"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="investigator.workplaceAssignation.expiration_date"
                  :label="$t('label.expirationDate')"
                  prepend-inner-icon="event"
                  readonly
                  outlined
                  v-on="on"
                  :rules="rules.fieldRequired"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="investigator.workplaceAssignation.expiration_date"
                @input="menu_exp_date = false"
                :readonly="disabledForm"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              :disabled="disabledForm"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="investigator.workplaceAssignation.change_date"
                  :label="$t('label.changeDate')"
                  prepend-inner-icon="event"
                  readonly
                  :disabled="investigator.workplaceAssignation.change_fast"
                  hide-details
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="investigator.workplaceAssignation.change_date"
                @input="menu = false"
                :readonly="disabledForm"
                :disabled="investigator.workplaceAssignation.change_fast"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox
              v-model="investigator.workplaceAssignation.change_fast"
              :label="$t('label.changeDate_soon')"
              :false-value="false"
              :true-value="true"
              @change="clickCheckbox"
              :readonly="disabledForm"
            />
          </v-col>
        </v-row>
        <v-divider />
        <UserFormActions
          form_name_text="Modify workplace"
          :form_name="form_name"
          :refForm="$refs.form"
          :object_type="object_type"
          :data="data"
          :state="state"
          @change-state="changeState"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [changeState, validationRules, investigatorData, investigator_model],
  components: { RejectCommentLayout, UserFormActions },

  data: () => ({
    menu: false,
    menu_exp_date: false,
    object_type: "investigator",
    form_name: "modifyWorkplaceForm",
    state: "",
    reject_comment: "",
    workplaceSelected: "",
    show_link: false
  }),

  created() {
    this.getWorkplaces();
    this.getData();
  },

  computed: {
    data() {
      let workplaceItem = "";
      if (this.workplaceSelected !== null) {
        if (typeof this.workplaceSelected == "string") {
          workplaceItem = {
            id: null,
            name: this.workplaceSelected
          };
        } else if (this.workplaceSelected.id != null) {
          workplaceItem = {
            id: null,
            name: this.workplaceSelected.name
          };
        } else {
          workplaceItem = this.workplaceSelected;
        }
      } else {
        workplaceItem = null;
      }
      return {
        title: this.investigator.name,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.investigator.id,
        data: {
          user: {
            workplaceAssignation: {
              id: workplaceItem,
              change_fast: this.investigator.workplaceAssignation.change_fast,
              change_date: this.investigator.workplaceAssignation.change_date,
              expiration_date: this.investigator.workplaceAssignation
                .expiration_date
            }
          }
        }
      };
    },
    pendingAssigment() {
      return this.state === "PA";
    },
    updateWorkplaceForm() {
      return this.$route.meta.updateForm;
    },
    rejectedForm() {
      return this.state === "RJ";
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    }
  },

  methods: {
    getData() {
      let path = "";
      if (this.updateWorkplaceForm || this.$route.meta.readOnly) {
        path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/investigator/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.investigator.workplaceAssignation =
              response.data.data.user.workplaceAssignation;
            this.state = response.data.state;
            this.reject_comment = response.data.reject_comment;
            this.investigator.id = response.data.object_id;
            this.getInvestigatorName(
              this.$store.state.endpoint + "/person/" + this.investigator.id
            );
            this.loadWorkplaceSelected(
              this.investigator.workplaceAssignation.id
            );
            this.getWorkplaceAssignation(this.investigator.id)
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.getInvestigatorName(
          this.$store.state.endpoint + "/person/" + this.$route.params.id
        );
        this.getExpirationDateVinculation(this.$route.params.id);
        this.getWorkplaceAssignation(this.$route.params.id)
      }
    },

    loadWorkplaceSelected(item) {
      if (typeof item == "number") {
        this.workplaceSelected = this.workplaces.filter(
          workplace => workplace.id === item
        )[0];
      } else {
        this.workplaceSelected = item;
      }
    },

    getExpirationDateVinculation(id) {
      let path = this.$store.state.endpoint + "/account/" + id;
      axios
        .get(path)
        .then(response => {
          if (response.data.expiration_date !== null) {
            this.investigator.workplaceAssignation.expiration_date =
              response.data.expiration_date;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clickCheckbox() {
      if (this.investigator.workplaceAssignation.change_fast) {
        this.investigator.workplaceAssignation.change_date = "";
      }
    },
    getWorkplaceAssignation(id) {
      let path =
        this.$store.state.endpoint + "/workplaceAssignation/last/" + id;
      axios
        .get(path)
        .then(response => {
          this.show_link = response.data.length === undefined;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
